import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { Button } from '@material-ui/core';
import { Field, reduxForm } from 'redux-form';
import { setPropsAsInitial } from '../../helpers/setPropsAsInitial';
import { isMobile } from 'react-device-detect';
import renderDatePicker from './../Complements/renderDatePicker'
import RenderTextFieldRedux from '../Complements/RenderTextFieldRedux';

const validate = values => {
    const error  = {}
    if (!values.cedule) {
        error.name = "El campo cedula es requerido"
    }
    if (!values.amount) {
        error.dni = "El monto es un campo obligatorio"
    }
    if (!values.description) {
        error.dni = "La descripcion es un campo obligatorio"
    }
    if (!values.date) {
        error.dni = "La fecha es un campo obligatorio"
    }
    return error
}
class CheckBookForm extends Component {
    state = { openDialog: false, selectedDate: this.props.date };
    handleDateChange = (date) => {
        return this.setState({ selectedDate: new Date(date) })
    }
    componentDidMount() {
      if (this.txt) {
        this.txt.focus();
      }
      if (isMobile) {
      }
    }
    openDialog = () => {
        this.setState({openDialog: true})
    }
    render() {
        const { classes, handleSubmit, findCustomer, owner, alert, QR, pristine, onCancel  } = this.props;
        return (
            <React.Fragment>
                <Typography variant="h6" gutterBottom>
                    { `Generar cheque ${owner}` }
                </Typography>
                <form className={classes.form} onSubmit={ handleSubmit }>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={3}>
                        <Field
                            withFocus
                            name="cedule"
                            id="cedule"
                            required
                            component={ RenderTextFieldRedux }
                            label="Cedula"
                            fullWidth
                            onChange ={ e => { 
                                ((e.target.value.length === 10) || (e.target.value.length === 13)) &&
                                    findCustomer(e.target.value)
                            } }
                        />
                        </Grid>
                        <Grid item xs={12} md={9}>
                            <Field
                                withFocus
                                name="owner"
                                id="owner"
                                disabled
                                component={ RenderTextFieldRedux }
                                label="Propietario"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <Field
                                withFocus
                                name="amount"
                                id="amount"
                                required
                                component={ RenderTextFieldRedux }
                                label="Monto"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <Field
                                withFocus
                                name="description"
                                id="description"
                                required
                                component={ RenderTextFieldRedux }
                                label="Descripcion"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Field
                                withFocus
                                name="dateSelected"
                                id="dateSelected"
                                type='date'
                                required
                                component={ renderDatePicker }
                                label="Fecha"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Button variant="contained" type="submit"
                                disabled={pristine}
                                // onClick = {() => {this.openDialog()}}
                                fullWidth
                                color="primary"
                                className={classes.submit}>
                                Continuar
                            </Button>
                        </Grid>
                        <Grid item xs={6} md={6}>
                            <Button variant="contained" className={classes.button} onClick = { () => onCancel() }>
                                Cancelar
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                        </Grid>
                    </Grid>
                </form>
                { alert }
                { QR }
            </React.Fragment>
        )
    }
}
const CheckBookFormReduxForm = reduxForm(
  {
    form: 'CheckBookForm',
    validate
  }
)(CheckBookForm)

CheckBookForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    // customers: PropTypes.object.isRequired,
    findCustomer: PropTypes.func.isRequired,
    owner: PropTypes.string,
    cedule: PropTypes.string,
};
export default setPropsAsInitial(CheckBookFormReduxForm)
// export default ChargesForm;